(() => {
  'use strict';

  if (window.__nilColorSwatchesV1) return;
  window.__nilColorSwatchesV1 = true;

  const CDN = 'https://cdn.shopify.com/s/files/1/1005/2278/7104/files/';

  const swatches = [
    { url: CDN + 'color-renk-mocha-moka.png', names: ['Mocha', 'Moka', 'Mocha Moka', 'color-renk-mocha-moka'] },
    { url: CDN + 'color-renk-sage-green-ada-cayi-yesili.png?v=1781811306', names: ['Sage Green', 'Ada Çayı Yeşili', 'Ada Cayi Yesili', 'Sage', 'color-renk-sage-green-ada-cayi-yesili'] },
    { url: CDN + 'color-renk-pearl-pink-inci-pembe.png?v=1781811306', names: ['Pearl Pink', 'İnci Pembe', 'Inci Pembe', 'color-renk-pearl-pink-inci-pembe'] },
    { url: CDN + 'color-renk-royal-blue-kraliyet-mavisi.png?v=1781811307', names: ['Royal Blue', 'Kraliyet Mavisi', 'color-renk-royal-blue-kraliyet-mavisi'] },
    { url: CDN + 'color-renk-gold-champagne-altin-sampanya.png?v=1781811307', names: ['Gold Champagne', 'Altın Şampanya', 'Altin Sampanya', 'color-renk-gold-champagne-altin-sampanya'] },
    { url: CDN + 'color-renk-navy-blue-lacivert.png?v=1781811306', names: ['Navy Blue', 'Navy', 'Lacivert', 'color-renk-navy-blue-lacivert'] },
    { url: CDN + 'color-renk-dusty-rose-gul-kurusu.png?v=1781811307', names: ['Dusty Rose', 'Gül Kurusu', 'Gul Kurusu', 'color-renk-dusty-rose-gul-kurusu'] },
    { url: CDN + 'color-renk-crimson-red-kirmizi.png?v=1781811306', names: ['Crimson Red', 'Crimson', 'Kırmızı', 'Kirmizi', 'Red', 'color-renk-crimson-red-kirmizi'] },
    { url: CDN + 'color-renk-soft-champagne-yumusak-sampanya.png?v=1781811306', names: ['Soft Champagne', 'Yumuşak Şampanya', 'Yumusak Sampanya', 'color-renk-soft-champagne-yumusak-sampanya'] },
    { url: CDN + 'color-renk-silver-gray-gumus-gri.png?v=1781811306', names: ['Silver Gray', 'Silver Grey', 'Gümüş Gri', 'Gumus Gri', 'color-renk-silver-gray-gumus-gri'] },
    { url: CDN + 'color-renk-deep-purple-koyu-mor.png?v=1781811307', names: ['Deep Purple', 'Koyu Mor', 'Purple', 'Mor', 'color-renk-deep-purple-koyu-mor'] },
    { url: CDN + 'color-renk-teal-turquoise-petrol-turkuaz.png?v=1781811306', names: ['Teal Turquoise', 'Teal', 'Turquoise', 'Petrol Turkuaz', 'color-renk-teal-turquoise-petrol-turkuaz'] },
    { url: CDN + 'color-renk-ivory-fildisi.png?v=1781811306', names: ['Ivory', 'Fildişi', 'Fildisi', 'color-renk-ivory-fildisi'] },
    { url: CDN + 'color-renk-emerald-green-zumrut-yesili.png?v=1781811306', names: ['Emerald Green', 'Emerald', 'Zümrüt Yeşili', 'Zumrut Yesili', 'color-renk-emerald-green-zumrut-yesili'] },
    { url: CDN + 'color-renk-black-siyah.png?v=1781811306', names: ['Black', 'Siyah', 'color-renk-black-siyah'] },
    { url: CDN + 'color-renk-soft-ivory-yumusak-fildisi.png?v=1781811306', names: ['Soft Ivory', 'Yumuşak Fildişi', 'Yumusak Fildisi', 'color-renk-soft-ivory-yumusak-fildisi'] },
    { url: CDN + 'color-renk-burgundy-bordo.png?v=1781811306', names: ['Burgundy', 'Bordo', 'color-renk-burgundy-bordo'] },
    { url: CDN + 'color-renk-champagne-sampanya.png?v=1781811306', names: ['Champagne', 'Şampanya', 'Sampanya', 'color-renk-champagne-sampanya'] },
    { url: CDN + 'color-renk-off-white-kirik-beyaz.png?v=1781811306', names: ['Off White', 'Off-White', 'Kırık Beyaz', 'Kirik Beyaz', 'color-renk-off-white-kirik-beyaz'] },
    { url: CDN + 'color-renk-white-beyaz.png?v=1781811306', names: ['White', 'Beyaz', 'color-renk-white-beyaz'] }
  ];

  const aliasMap = new Map();
  let sortedKeys = [];

  function normalize(value) {
    return String(value || '')
      .replace(/İ/g, 'I')
      .replace(/ı/g, 'i')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function addAlias(name, item) {
    const key = normalize(name);
    if (key) aliasMap.set(key, item);
  }

  swatches.forEach((item) => {
    const payload = { url: item.url, label: item.names[0] };
    item.names.forEach((name) => addAlias(name, payload));
    item.names.forEach((name) => addAlias('color ' + name, payload));
    item.names.forEach((name) => addAlias('renk ' + name, payload));
  });

  sortedKeys = Array.from(aliasMap.keys()).sort((a, b) => b.length - a.length);

  function lookup(value) {
    const key = normalize(value);
    if (!key) return null;

    if (aliasMap.has(key)) return aliasMap.get(key);

    const stripped = key
      .replace(/^color-renk-/, '')
      .replace(/^color-/, '')
      .replace(/^renk-/, '');

    if (aliasMap.has(stripped)) return aliasMap.get(stripped);

    for (const alias of sortedKeys) {
      if (key === alias || key.startsWith(alias + '-') || key.endsWith('-' + alias) || key.includes('-' + alias + '-')) {
        return aliasMap.get(alias);
      }
    }

    return null;
  }

  function getInput(label) {
    if (!label) return null;
    if (label.matches && label.matches('input')) return label;
    return label.querySelector?.('input[type="radio"], input[type="checkbox"]') ||
      (label.htmlFor ? document.getElementById(label.htmlFor) : null);
  }

  function textCandidates(label) {
    const input = getInput(label);
    const root = label.closest?.('.variant-option, fieldset, .product-form__input, [data-option-name]');
    const textNode = label.querySelector?.('.variant-option__button-label__text, .swatch__label, [data-option-value]');

    return [
      label.dataset?.optionValue,
      label.getAttribute?.('data-option-value'),
      label.getAttribute?.('data-value'),
      label.getAttribute?.('aria-label'),
      label.getAttribute?.('title'),
      input?.value,
      input?.getAttribute?.('aria-label'),
      input?.dataset?.optionValue,
      textNode?.textContent,
      label.textContent,
      root?.getAttribute?.('data-option-value')
    ].filter(Boolean).map((value) => String(value).trim()).filter(Boolean);
  }

  function isProbablyColorOption(label) {
    const root = label.closest?.('.variant-option, fieldset, .product-form__input, [data-option-name]');
    const labelText = [
      root?.getAttribute?.('data-option-name'),
      root?.querySelector?.('legend')?.textContent,
      root?.querySelector?.('.form__label')?.textContent,
      root?.querySelector?.('[class*="label"]')?.textContent
    ].filter(Boolean).join(' ');

    const normalized = normalize(labelText);
    return normalized.includes('color') || normalized.includes('colour') || normalized.includes('renk');
  }

  function findSwatch(label) {
    const candidates = textCandidates(label);

    for (const candidate of candidates) {
      const match = lookup(candidate);
      if (match) return match;
    }

    if (!isProbablyColorOption(label)) return null;

    return null;
  }

  function ensureDot(label) {
    let dot = label.querySelector?.(':scope > .nil-color-swatch-dot');
    if (!dot) {
      dot = document.createElement('span');
      dot.className = 'nil-color-swatch-dot';
      dot.setAttribute('aria-hidden', 'true');
      label.appendChild(dot);
    }
    return dot;
  }

  function decorate(label) {
    if (!(label instanceof HTMLElement)) return;
    if (label.dataset.nilColorSwatchDecorated === 'true') return;

    const swatch = findSwatch(label);
    if (!swatch) return;

    label.dataset.nilColorSwatchDecorated = 'true';
    label.classList.add('nil-color-image-swatch');
    label.style.setProperty('--nil-color-image', `url("${swatch.url}")`);
    label.setAttribute('title', swatch.label);

    if (!label.getAttribute('aria-label')) {
      label.setAttribute('aria-label', swatch.label);
    }

    const root = label.closest('.variant-option, fieldset, .product-form__input');
    if (root) root.classList.add('nil-color-swatch-root');

    ensureDot(label);
  }

  function updateState(root = document) {
    root.querySelectorAll?.('.nil-color-image-swatch').forEach((label) => {
      const input = getInput(label);
      const selected = Boolean(input?.checked) || label.getAttribute('aria-checked') === 'true' || label.getAttribute('aria-pressed') === 'true';
      const unavailable = Boolean(input?.disabled) || input?.getAttribute('aria-disabled') === 'true' || input?.dataset?.optionAvailable === 'false' || label.getAttribute('aria-disabled') === 'true';

      label.classList.toggle('nil-swatch-selected', selected);
      label.classList.toggle('nil-swatch-unavailable', unavailable);
    });
  }

  function decorateAll(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const candidates = scope.querySelectorAll?.('.variant-option__button-label, .product-form__input label, label[for], button[data-option-value], button[aria-pressed], [role="radio"]');

    candidates?.forEach(decorate);
    updateState(scope);
  }

  let frame = 0;
  function schedule(root = document) {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => decorateAll(root));
  }

  function setPreviewPosition(label) {
    const rect = label.getBoundingClientRect();
    label.classList.toggle('nil-preview-below', rect.top < 130);
  }

  document.addEventListener('mouseover', (event) => {
    const label = event.target.closest?.('.nil-color-image-swatch');
    if (label) setPreviewPosition(label);
  }, true);

  document.addEventListener('focusin', (event) => {
    const label = event.target.closest?.('.nil-color-image-swatch');
    if (label) setPreviewPosition(label);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest?.('.nil-color-swatch-root, .variant-picker, form[action*="/cart/add"]')) {
      window.setTimeout(() => updateState(document), 0);
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('.nil-color-image-swatch, .variant-picker')) {
      window.setTimeout(() => updateState(document), 0);
    }
  }, true);

  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  document.addEventListener('shopify:block:select', (event) => schedule(event.target));
  document.addEventListener('variant:change', () => updateState(document));
  document.addEventListener('product:variant-change', () => updateState(document));

  const observer = new MutationObserver(() => schedule(document));

  function init() {
    decorateAll(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
